import $ from 'jquery';
window.$ = window.jQuery = $;

$(document).ready(function () {
	// $('.section-row-media-grid > .media-grid').lbtLightBox({
	// 			  pagination_width: "120px",
	// 			  pagination_height: "120px",
	// 			  custom_children: ".media-grid-item img",
	// 			  captions: false,
	// 			});


	
	// var accordgallery = $('div.accordion-gallery');

	// if (accordgallery) {
	// 	for( var i in accordgallery){
	// 		$('#' + accordgallery[i].id + ' .media-grid').lbtLightBox({
	// 			  pagination_width: "120px",
	// 			  pagination_height: "120px",
	// 			  custom_children: ".media-grid-item img",
	// 			  captions: false,
	// 			});
	// 	}
	// }
});